let deferred = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; localStorage.setItem("m_installed", "1"); emit(); });
}

export const canPrompt = () => !!deferred;
export const onInstallChange = (f) => { subs.add(f); return () => subs.delete(f); };

export async function promptInstall() {
  if (!deferred) return "unavailable";
  const e = deferred;
  e.prompt();
  const { outcome } = await e.userChoice;
  deferred = null;
  if (outcome === "accepted") localStorage.setItem("m_installed", "1");
  emit();
  return outcome;
}
